module.exports = __webpack_public_path__ + "img/a_new_tool.213108b3.svg";